import { DataSyncReconnectButton } from './DataSyncReconnectButton';
import { AppConnectionStatuses } from '../../../../constants/appConnectionStatuses';
export const DataSyncReconnectionConfig = {
  reconnectButton: DataSyncReconnectButton,
  statusesForDisplaying: [AppConnectionStatuses.DISCONNECTED]
};